import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudformation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "-28 0 312 312",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.491,215.53 L18.667,218 L128.582,249.157 L129.08,229.844 L52.1,210.526 L48.333,209.167 L16.491,215.53",
			fill: "#B7CA9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239.505,215.53 L127.25,253 L126.916,229.844 L203.895,210.526 L207.25,206.75 L239.505,215.53",
			fill: "#B7CA9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.916,83.165 L203.895,101.106 L237.75,99.5 L239.505,96.107 L132.25,57.5 L126.916,83.165",
			fill: "#3C4929"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.1,210.526 L16.491,215.53 L15.5,211.833 L15.5,100 L16.491,96.107 L48.667,98.5 L52.1,101.11 L52.1,210.526",
			fill: "#759C3E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.08,83.165 L52.1,101.106 L16.491,96.107 L17.833,94 L128.582,62.48 L129.08,83.165",
			fill: "#3C4929"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.846,0 L0,64.531 L0.061,247.144 L127.846,311.641 L129.75,308.75 L129.75,3.75 L127.846,0 L127.846,0 Z M90.462,237.73 L16.491,215.53 L16.491,96.107 L90.462,73.915 L90.462,237.73 L90.462,237.73 Z",
			fill: "#4B612C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.895,210.526 L239.505,215.53 L241.5,212 L241.5,99.5 L239.505,96.107 L203.895,101.11 L203.895,210.526",
			fill: "#4B612C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.846,311.641 L255.939,247.148 L256,64.536 L127.846,0 L127.846,311.641 L127.846,311.641 Z M165.533,73.915 L239.505,96.107 L239.505,215.53 L165.533,237.73 L165.533,73.915 L165.533,73.915 Z",
			fill: "#759C3E"
		})
	] })
});
export default SvgCloudformation;
